import React from "react";
import { useRef } from "react";
import {
  Card,
  Space,
  List,
  Select,
  Drawer,
  Checkbox,
  message,
  Form,
  notification,
} from "antd";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { SettingOutlined, HolderOutlined } from "@ant-design/icons";

import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import useWindowSize from "../../../utils/useWindowSize";
import UseFullLoader from "../../FullPageLoader/UseFullLoader";
import { useEffect } from "react";
import {
  calculateAvailableColumnValue,
  calculateFixedColumnValue,
  generateAvailableColumns,
  generateColumnSeqeuenceNo,
  generateDefaultFieldArray,
  generateFixedColumns,
  generateSaveColumnListRequest,
} from "../../PartnerManagement/PartnerManagementListing/helperFunction";
import { connect, useDispatch } from "react-redux";
import {
  getCommonListing,
  getColumnsMaster,
  updateColumnsMaster,
  getDynamicTabs,
  getTabStatusCount,
  TabsActionButtonsList,
  setTab,
} from "../../../redux/AccessManagement/AccessManagementAction";
import {
  fetchAppDetails,
  fetchAppTopSec,
  assignedToMeApp,
  getAppDataCount,
} from "../../../redux/Application/actions";
import MyServices from "../../MyServices/MyServices";
import "./AccessManagement.css";
import AccessManagementService from "./AccessManagementService";
import AccessManagementActionButtons from "../../../DynamicData/AccessManagementActionButtons.json";
import useSession from "../../CustomLogout/useSession";

function AccessManagementListing({ userRefresh, setUserRefresh, ...props }) {
  const TAB_NAME_MAPPING = useRef({});
  const { access_token, updateColumnsListData } = props;
  const dispatch = useDispatch();
  const [toggleState, setToggleState] = useState(1);
  const [listingData, setlistingData] = useState([]);

  const history = useNavigate();

  const [columnsDto, setColumnsDto] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectedColumnsPrevState, setSelectedColumnsPrevState] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState("");
  const [hiddenCols, setHiddenCols] = useState([]);
  const [listingMaster, setListingMaster] = useState("");
  const [fixedColumns, setFixedColumns] = useState([]);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [columnsOrder, setColumnsOrder] = useState([]);
  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState("");
  const [tabIndex, setTabIndex] = useState(0);

  const [searchMainData, setSearchMainData] = useState([]);
  const [searchColData, setSearchColData] = useState("");
  const [searchStatus, setSearchStatus] = useState(false);

  // const [processType, setProcessType] = useState("STP");
  const [statusCount, setStatusCount] = useState(null);
  const [{ pageSize, pageIndex }, setPagination] = useState({
    pageSize: 10,
    pageIndex: 0,
  });

  const pagination = useMemo(
    () => ({
      pageSize,
      pageIndex,
    }),
    [pageSize, pageIndex]
  );

  const [actionButtonData, setActionButtonData] = useState([]);

  const { width } = useWindowSize();

  const [loader, showLoader, hideLoader] = UseFullLoader();
  const handleSessionExpired = useSession();

  const roleTypeList =
    props.addEmployeeData?.getAddEmployee?.length > 0
      ? props.addEmployeeData?.getAddEmployee.map((el) => {
          return {
            label: el.role,
            value: el.role,
          };
        })
      : [];

  useEffect(() => {
    if (selectedTab) {
      getActionDataList(selectedTab);
    }
  }, [selectedTab]);

  useEffect(() => {
    if (selectedTab && !userRefresh) {
      getApplicationList();
    }
  }, [pageIndex, pageSize, selectedTab]);

  const getActionDataList = (selectedTab) => {
    props
      .getActionData({
        access_token,
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            const actionData =
              res &&
              res.data &&
              res.data.ACTION_BUTTON_DTO &&
              res.data.ACTION_BUTTON_DTO.list;

            const actionDataList =
              actionData.length > 0
                ? actionData.filter((item) => item.tabName === selectedTab)
                : [];

            setActionButtonData(actionDataList);
          }
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          hideLoader();

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            hideLoader();
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const getTabStatusCountData = () => {
    props.getTabStatusCount({ access_token }).then((res) => {
      if (res.success?.status == 200) {
        let temp = {};
        let tabs = [];
        res.tabCaseCount.forEach((item) => {
          TAB_NAME_MAPPING.current = {
            ...TAB_NAME_MAPPING.current,
            [item.tab]: item.tabName,
          };
          temp[item.tab] = item.caseCount;
          tabs.push(item.tab);
        });
        let tabName = tabs[0];
        if (!userRefresh) {
          setSelectedTab(tabName);
        }
        setTabs([...tabs]);
        setStatusCount({
          nstpCount: res.nstpCaseCount,
          stpCount: res.stpCaseCount,
          ...temp,
        });
      }
    });
  };

  useEffect(() => {
    getTabStatusCountData();
  }, []);

  useEffect(() => {
    if (userRefresh) {
      getTabStatusCountData();
      message.destroy();

      getApplicationList(status);
    }
  }, [userRefresh]);

  const getApplicationList = (tabStatus) => {
    showLoader();
    props
      .getListing({
        access_token,
        sortField: "userId",
        sortOrder: "desc",
        tabName: tabStatus,
        tab: selectedTab,
        searchData: searchMainData,
        pageSize,
        pageIndex,
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            setUserRefresh(false);
            const fields = res?.data?.userFieldsDto?.fields;
            hideLoader();
            // setTableLoader(false);
            let tempData = [];
            res?.data?.dtoList.forEach((item, index) => {
              let obj = { ...item };
              let currentDate = new Date();
              let difference = obj.createdOn - currentDate.getTime();
              let dayMilliSeconds = 1000 * 60 * 60 * 24;
              let hourMilliSeconds = 1000 * 60 * 60;
              obj.partnerFirmId = item.partnerFirmId;

              let days = Math.floor(Math.abs(difference / dayMilliSeconds));
              let hours = Math.floor(
                Math.abs(Math.abs(difference / hourMilliSeconds) % 24)
              );
              obj.age = `${days} Days ${hours} Hours`;
              // obj.createdOn=moment(obj.createdOn||0).format("DD-MM-YYYY")
              // obj.age=difference(obj.createdOn);
              tempData.push(obj);
            });

            setlistingData(tempData);
            // setLanNumberVisible(lanNumberVisble => !lanNumberVisble);
            setListingMaster(res?.data?.userFieldsDto?.listingMaster);
            setColumnsDto([...fields]);
            const fieldArray = generateDefaultFieldArray(fields);
            setSelectedColumns(fieldArray);
            setHiddenCols(fieldArray);
            setColumnsOrder(fieldArray);
            // setFixedColumns(generateFixedColumns(fields));
            // setAvailableColumns(generateAvailableColumns(fields));
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            hideLoader();

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              hideLoader();

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        } else {
          hideLoader();
        }
      });
  };

  const toggleTab = (tab, index) => {
    console.log("tabtabtab", tab);
    dispatch(setTab(tab));
    setSelectedTab(tab);
    setToggleState(index);
    setSearchMainData([]);

    setPagination({
      // pageSize: 10,
      ...pagination,
      pageIndex: 0,
    });
  };

  const searchSelectColumnName = (columnData) => {
    switch (columnData?.fieldName) {
      case "roleType":
        return "roleType";

      default:
        return columnData?.fieldName;
    }
  };

  const handleToggleSort = (column, sortBy) => {
    showLoader();
    const columnData = columnsDto.find((ele) => ele.fieldId === column.id);
    props
      .getListing({
        access_token,
        sortField: searchSelectColumnName(columnData),
        sortOrder: sortBy,
        tabName: status,
        searchData: searchMainData,
        tab: selectedTab,
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            const fields = res?.data?.userFieldsDto?.fields;
            hideLoader();
            // setTableLoader(false);
            let tempData = [];
            res?.data?.dtoList.forEach((item, index) => {
              let obj = { ...item };
              let currentDate = new Date();
              let difference = obj.createdOn - currentDate.getTime();
              let dayMilliSeconds = 1000 * 60 * 60 * 24;
              let hourMilliSeconds = 1000 * 60 * 60;
              obj.partnerFirmId = item.partnerFirmId;

              let days = Math.floor(Math.abs(difference / dayMilliSeconds));
              let hours = Math.floor(
                Math.abs(Math.abs(difference / hourMilliSeconds) % 24)
              );
              obj.age = `${days} Days ${hours} Hours`;
              // obj.createdOn=moment(obj.createdOn||0).format("DD-MM-YYYY")
              // obj.age=difference(obj.createdOn);
              tempData.push(obj);
            });

            setlistingData(tempData);
            // setLanNumberVisible(lanNumberVisble => !lanNumberVisble);
            setListingMaster(res?.data?.userFieldsDto?.listingMaster);
            setColumnsDto([...fields]);
            const fieldArray = generateDefaultFieldArray(fields);
            setSelectedColumns(fieldArray);
            setHiddenCols(fieldArray);
            setColumnsOrder(fieldArray);
            // setFixedColumns(generateFixedColumns(fields));
            // setAvailableColumns(generateAvailableColumns(fields));
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            hideLoader();

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              hideLoader();

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        } else {
          hideLoader();
        }
      });
  };

  useEffect(() => {
    if (searchMainData.length > 0) {
      showLoader();
      const columnData = columnsDto.find(
        (ele) => ele.fieldId === searchColData.id
      );

      props
        .getListing({
          access_token,
          sortField: searchSelectColumnName(columnData),
          sortOrder: searchColData.isSortedDesc ? "desc" : "asc",
          searchData: searchMainData,
          // searchData: [
          //   {
          //     search: `${value}`,
          //     searchCol: `${columnData.fieldName}`,
          //     searchType: "CONTAINS",
          //   },
          // ],

          // tabName: status,
          tab: selectedTab,
        })
        .then((res) => {
          if (res && res.status === 200) {
            const fields = res?.data?.userFieldsDto?.fields;
            hideLoader();

            let tempData = [];
            res?.data?.dtoList.forEach((item, index) => {
              let obj = { ...item };
              let currentDate = new Date();
              let difference = obj.createdOn - currentDate.getTime();
              let dayMilliSeconds = 1000 * 60 * 60 * 24;
              let hourMilliSeconds = 1000 * 60 * 60;
              obj.leadId = item.leadId;

              let days = Math.floor(Math.abs(difference / dayMilliSeconds));
              let hours = Math.floor(
                Math.abs(Math.abs(difference / hourMilliSeconds) % 24)
              );
              obj.age = obj.createdOn ? `${days} Days ${hours} Hours` : "NaN";

              tempData.push(obj);
            });

            setlistingData(tempData);
            setListingMaster(res?.data?.userFieldsDto?.listingMaster);
            setColumnsDto([...fields]);
            const fieldArray = generateDefaultFieldArray(fields);
            setSelectedColumns(fieldArray);
            setHiddenCols(fieldArray);
            setColumnsOrder(fieldArray);
          } else if (res?.data?.error) {
            hideLoader();
            if (res && res.data && res.data.error && res.data.error.message) {
              message.error(res.data.error.message, 2);
              hideLoader();
            }
          }
        });
    } else {
      if (searchStatus) getApplicationList();
    }
  }, [searchMainData]);

  const onSearch = (value, column) => {
    const columnData = columnsDto.find((ele) => ele.fieldId === column.id);
    setSearchStatus(true);
    if (value !== "") {
      setSearchColData(column);

      const index = searchMainData.findIndex(
        (item) => item.searchCol === searchSelectColumnName(columnData)
      );

      if (index > -1) {
        setSearchMainData((prev) => {
          const temp = [...prev];
          temp[index].search = value;
          return temp;
        });
      } else {
        setSearchMainData((prev) => {
          const temp = [...prev];
          temp.push({
            search: `${value}`,
            searchCol: `${searchSelectColumnName(columnData)}`,
            searchType:
              columnData?.dataType === "DROPDOWN" ||
              columnData?.dataType === "SEARCH_DROPDOWN"
                ? "EQUAL"
                : "CONTAINS",
          });
          return temp;
        });
      }
    } else if (value === "" && searchMainData?.length > 0) {
      const index = searchMainData.findIndex(
        (item) => item.searchCol === searchSelectColumnName(columnData)
      );

      if (index > -1) {
        setSearchMainData((prev) => {
          const temp = [...prev];
          temp.splice(index, 1);
          return temp;
        });
      }
    }
  };

  return (
    <div className="dashboard">
      <div
        className="site-card-wrapper"
        style={{ maxWidth: "100%", position: "relative" }}
      >
        <div style={{ paddingTop: "0px", maxWidth: "100%" }}>
          <Space direction={"vertical"} className="w-100">
            <Row style={{ maxWidth: "100%" }}>
              <Col style={{ paddingTop: 20 }}>
                {width > 786 && (
                  <div className="block-tabs w-30 h-60px">
                    {tabs.map((item, index) => (
                      <button
                        className={
                          toggleState === index + 1
                            ? "tabs active-tabs"
                            : "tabs"
                        }
                        onClick={() => toggleTab(item, index + 1)}
                      >
                        {TAB_NAME_MAPPING.current[item]}
                        <span
                          className={
                            statusCount &&
                            (statusCount[item] >= 100000
                              ? "listCountMoreThan100000"
                              : statusCount[item] >= 10000
                              ? "listCountMoreThan10000"
                              : statusCount[item] >= 1000
                              ? "listCountMoreThan1000"
                              : statusCount[item] >= 100
                              ? "listCountMoreThan100"
                              : "listCount")
                          }
                        >
                          {" "}
                          {statusCount ? statusCount[item] : ""}
                        </span>
                      </button>
                    ))}
                  </div>
                )}

                {width < 786 && (
                  <div className="block-tabs-mobile">
                    <select
                      className="block-tabs-mobile-select"
                      onChange={(e) =>
                        toggleTab(
                          e.target.value,
                          tabs.indexOf(e.target.value) + 1
                        )
                      }
                      defaultValue={tabs[0]}
                    >
                      {tabs.length === 0 && (
                        <option value="">Select Tab</option>
                      )}
                      {tabs.map((item, index) => (
                        <option
                          value={item}
                          onClick={() => setTabIndex(index + 1)}
                        >
                          {TAB_NAME_MAPPING.current[item]}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* {!loader && columnsDto && columnsDto.length > 0 && (
                  <button
                    className="Fixedcol-icon"
                    type="primary"
                    onClick={showDrawer}
                  >
                    <SettingOutlined />
                  </button>
                )} */}

                {loader}

                <div className="content-tabs">
                  {tabs.map((item, index) => (
                    <div
                      className={
                        toggleState === index + 1
                          ? "content  active-content"
                          : "content"
                      }
                    >
                      <AccessManagementService
                        domainData={listingData}
                        statusType={index + 1}
                        columnsData={columnsDto}
                        hiddenColumns={hiddenCols}
                        columnsOrder={columnsOrder}
                        handleToggleSort={handleToggleSort}
                        onSearch={onSearch}
                        actionDataList={actionButtonData}
                        pageTotalCount={statusCount && statusCount[selectedTab]}
                        pageIndex={pageIndex}
                        pageSize={pageSize}
                        setPagination={setPagination}
                        pagination={pagination}
                        setPartnerRefresh={setUserRefresh}
                        partnerRefresh={userRefresh}
                        roleTypeList={roleTypeList}
                        selectedTab={selectedTab}
                      />
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Space>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    getListing: (data) => dispatch(getCommonListing(data)),
    getColumnListData: (details) => dispatch(getColumnsMaster(details)),
    getDynamicTabs: (details) => dispatch(getDynamicTabs(details)),
    updateColumnsListData: (details) => dispatch(updateColumnsMaster(details)),
    getApplicationData: (data) => dispatch(fetchAppDetails(data)),
    getTabStatusCount: (data) => dispatch(getTabStatusCount(data)),
    getAppTopSecData: (data) => dispatch(fetchAppTopSec(data)),
    assignedtomedata: (data) => dispatch(assignedToMeApp(data)),
    getAppDataCount: (data) => dispatch(getAppDataCount(data)),
    getActionData: (data) => dispatch(TabsActionButtonsList(data)),
  };
};
const mapStateToProps = (state) => {
  return {
    access_token: state.auth.idToken,
    addEmployeeData: state.addEmployeeData,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccessManagementListing);
